import setHeight from './set-height';

export default {
  setHeight,
};
